import { apiCall } from "../../../services/api-service.js";

export const getDeleteGate = async (gateId) => {
  return await apiCall("DELETE", `gate/delete/${gateId}`);
};

export const getGateDetailsApi = async (gateId) => { 
  const response = await apiCall("GET", `gate/get/${gateId}`);
  return response.data;
};

export const updateGateApi = async (data,gateId) => {  
  return await apiCall("PUT", `gate/${gateId}`, data);
};

 
 